import { noop } from '@unistocks/shared/utils/util';

export const withFeedback = noop;
